module.exports = __webpack_public_path__ + "static/media/Csharp4.159f5060.png";